module.exports = __webpack_public_path__ + "static/media/message-submission.a305d03e.png";